<script>
import _ from "lodash";
import EvaluationSheetPDF from "../../../../makepdfs/study/evaluation_sheet_pdf";

export default {
  name: "CardViewingCommentForMethologist",
  props: {
    select_comment: {
      type: Object
    },
    selected_tech_map:{
      type: Object
    }
  },
  data: () => ({
    active_expand: false
  }),
  computed: {
    current_addit_message() {
      return this.select_comment.addit_message
    },
  },
  methods: {
    setIndexWindowListComments() {
      this.$emit('setIndexWindowListComments')
    },
    setIndexParent(parent_item) {
      let index_parent = _.findIndex(this.select_comment.data_result, ['parameter_name', parent_item.parameter_name])

      return index_parent + 1
    },
    setIndexChild(parent_item, child_item) {
      let index_parent = _.findIndex(this.select_comment.data_result, ['parameter_name', parent_item.parameter_name])
      let children_element = _.findIndex(this.select_comment.data_result[index_parent].content, ['name', child_item.name])

      children_element += 1
      index_parent += 1

      return index_parent + "." + children_element
    },
    setStatusEstimation(status_estimation) {
      if (status_estimation === 2) {
        return {color: 'green', icon: 'fa fa-check-circle'}
      } else if (status_estimation === 3) {
        return {color: 'red', icon: 'fa fa-times-circle'}
      }
      return {color: 'orange', icon: 'fa fa-exclamation-circle'}
    },
    setGlobalStatus(status_estimation_global){
      if (status_estimation_global === 2) return {color: 'green', icon: 'fa fa-check-circle'}
      if (status_estimation_global === 3) return {color: 'red', icon: 'fa fa-times-circle'}

      return {color: 'orange', icon: 'fa fa-exclamation-circle'}
    },
    createFileES(){
      EvaluationSheetPDF.createPDF(this.selected_tech_map, this.selected_tech_map.list_disciplines[0], this.select_comment.data_result, this.select_comment.addit_message)
    }
  }
}
</script>

<template>
  <v-card elevation="0" height="100%" class="overflow-hidden">
    <div class="d-flex justify-start position-relative">
      <v-btn
          @click="createFileES"
          elevation="0"
          class="edit-btn ma-2"
          x-small
          fab
          outlined
          color="teal"
      >
        <v-icon size="15px">
          fa-download
        </v-icon>
      </v-btn>
    </div>
    <v-card-title style="width: 100%">
      <v-btn icon @click="setIndexWindowListComments">
        <v-icon size="15px">
          fa-chevron-left
        </v-icon>
      </v-btn>
      Оценочный лист
    </v-card-title>

    <v-divider/>

    <v-card-text style="height: calc(100% - 68px);" class="mt-2 overflow-auto">
      <v-row>
        <v-col cols="5">
          <v-card elevation="0" class="rounded-xl" outlined>
            <v-list :flat="true" :shaped="true">
              <template v-for="(section, index) in select_comment.data_result">
                <v-list-group
                    v-if="section.content.length > 0"
                    active-class="teal--text"
                    :key="section.id"
                    :value="true"
                    :sub-group="true"
                    :expand="false"
                    no-action
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title class="text-h5">
                        <v-icon
                            :color="setGlobalStatus(section.status_estimation_global).color"
                            size="15px"
                            left
                        >
                          {{ setGlobalStatus(section.status_estimation_global).icon }}
                        </v-icon>
                        {{ setIndexParent(section) + " " + section.parameter_name }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <v-card elevation="0" class="text--secondary text-subtitle-1">
                          <v-icon
                              v-if="section.comments.length > 0"
                              color="orange"
                              size="15px"
                              left
                          >
                            fa fa-comments
                          </v-icon>
                          {{ section.comments }}
                        </v-card>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                  <v-list-item
                      v-if="section.content.length > 0"
                      v-for="child_section in section.content"
                      :key="child_section.id"
                  >
                    <v-list-item-content v-if="child_section.name !== 'Консультации'">
                      <v-list-item-title>
                        <v-card class="text-h6">
                          <v-icon
                              :color="setStatusEstimation(child_section.status_estimation).color"
                              size="15px"
                              left
                          >
                            {{ setStatusEstimation(child_section.status_estimation).icon }}
                          </v-icon>
                          {{ setIndexChild(section, child_section) + " " + child_section.name }}
                        </v-card>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <v-card class="text--secondary text-subtitle-1">
                          <v-icon
                              v-if="child_section.comments.length > 0"
                              color="orange"
                              size="15px"
                              left
                          >
                            fa fa-comments
                          </v-icon>
                          {{ child_section.comments }}
                        </v-card>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
                <v-list-item v-else>
                  <v-list-item-content>
                    <v-list-item-title class="text-h5">
                      <v-card elevation="0">
                        <v-icon
                            :color="setGlobalStatus(section.status_estimation_global).color"
                            size="15px"
                            left
                        >
                          {{ setGlobalStatus(section.status_estimation_global).icon }}
                        </v-icon>
                        {{ setIndexParent(section) + " " + section.parameter_name }}
                      </v-card>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <v-card elevation="0" class="text--secondary text-subtitle-1">
                        <v-icon
                            v-if="section.comments.length > 0"
                            color="orange"
                            size="15px"
                            left
                        >
                          fa fa-comments
                        </v-icon>
                        {{ section.comments }}
                      </v-card>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="7">
          <div v-if="current_addit_message.length === 0" class="d-flex justify-center mt-4">
            Дополнительные комментарии отсутствуют
          </div>
          <v-textarea
              v-else
              class="mt-4 rounded-xl"
              :value="current_addit_message"
              auto-grow
              readonly
              outlined
              label="Дополнительно"
          >
          </v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.rotate-caret {
  transform:rotate(180deg) ;
}
.edit-btn {
  position: absolute;
  top: 0;
  right: 0;
}

</style>